export default "assets/images/deezer-94723ef7.svg";